<template>
  <layout-with-sidebar>

    <HeaderComponent/>

    <div class=" ed-bg text-color">
      <br>
      <h1 class="h3 mb-3 font-weight-normal text-color text-center">Impostazione Notifiche</h1>
      <div>

        <!-- <b-form class=" custom-centered" > -->
        <form>

          <div class="container text-left">

            <div class="row">
              <div class="col-8">
                <h4>Giorni di preavviso scadenza rata</h4>
                <label>Indica i giorni di preavviso per avvisarti quando sta per scadere una rata</label>
                <div class="input-group mb-3">

                  <input v-model="user_form.alert_days" type="number" class="form-control"
                         placeholder="2">
                  <div class="input-group-append">
                    <span class="input-group-text">giorni</span>
                  </div>

                </div>


              </div>
              <div class="col-4">
                <h4>&nbsp;</h4>
                <label>Notifica Abilitata</label>
                <select class="form-control" v-model="user_form.has_notified_alert_rate_deadline">
                  <option value="true">Sì</option>
                  <option value="false">No</option>
                </select>
              </div>
              <br><br>

            </div>
            <div class="row">
              <div class="col-12">
                <h4>Indirizzi Email di notifica</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-4">
                <label>La tua email di registrazione</label>
                <input v-model="loggedUser.email" type="email" class="form-control" disabled>
              </div>
              <div class="col-12 col-lg-4">
                <label>Email secondaria</label>
                <input v-model="user_form.notify_email2" type="email" class="form-control">
              </div>
              <div class="col-12 col-lg-4">
                <label>Altro indirizzo email</label>
                <input v-model="user_form.notify_email3" type="email" class="form-control">
              </div>
            </div>

            <button type="submit" class="btn btn-lg btn-success btn-block mt-4" variant="primary"
                      @click.prevent="modify()">Salva
            </button>
          </div>

        </form>
        <!-- <b-card class="mt-3" header="Form Data Result">
          <pre class="m-0">{{ form }}</pre>
        </b-card> -->
        <br>
        <br>
      </div>

    </div>

  </layout-with-sidebar>
</template>


<script>
import axios from "axios";

import LayoutWithSidebar from "@/components/layouts/LayoutWithSidebar";

import HeaderComponent from "../../components/HeaderComponent.vue";

export default {
  name: "NotifySettings", //this is the name of the component
  components: {
    LayoutWithSidebar: LayoutWithSidebar,
    HeaderComponent: HeaderComponent
  },
  data: function () {
    return {
      responseOk: false,
      errors: {},
      user: {},
      user_form: {
        alert_days: 0,
        has_notified_alert_rate_deadline: 1,
        notify_email2: null,
        notify_email3: null
      },
      show: true
    };
  },
  mounted: function () {
    this.getUser();
  },
  computed: {},
  methods: {
    getUser: function () {
      var $vm = this;
      axios
          .get(
              process.env.VUE_APP_API_BASE_URL + "/api/v1/user/" + $vm.loggedUser.id
          )
          .then(function (response) {
            $vm.user = response.data;
            $vm.user_form.alert_days = $vm.user.alert_days
            $vm.user_form.has_notified_alert_rate_deadline = $vm.user.has_notified_alert_rate_deadline
            $vm.user_form.notify_email2 = $vm.user.notify_email2
            $vm.user_form.notify_email3 = $vm.user.notify_email3
          });
    },
    modify: function () {
      var $vm = this;

      $vm.responseOk = false;
      $vm.user.alert_days = this.user_form.alert_days
      $vm.user.has_notified_alert_rate_deadline = this.user_form.has_notified_alert_rate_deadline
      $vm.user.notify_email2 = this.user_form.notify_email2
      $vm.user.notify_email3 = this.user_form.notify_email3

      axios
          .patch(
              process.env.VUE_APP_API_BASE_URL + "/api/v1/user/" + $vm.user.id,
              $vm.user
          )
          .then(function (response) {
            $vm.responseOk = true;
            //$vm.$router.push({name: 'register-success'})
            //var loginData = {username: $vm.user.username, password: $vm.user.plainPassword}
            //axios.post(process.env.VUE_APP_API_BASE_URL+'/api/v1/login', loginData)
            //  .then(function (response) {
            //    $vm.$cookies.set('token', response.data.token)
            //    $vm.$cookies.set('user', response.data.user)
            //    $vm.$router.push({name: 'home'})
            //  })
            $vm.$toasted.show('Profilo salvato con successo!', {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 1300,
              type: 'success',
              class: 'toast'
            })


          })
          .catch(function (error) {
            $vm.errors = error.response.data;
          });
    }
  }
};
</script>

<style scoped>
.custom-centered {
  margin: 0 auto;
  width: 300px;
}

.text-color {
  color: white;
}

.ed-bg {
  background-color: #272f44;
  background-color: #222939;
}


.pricing-header {
  color: white;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}

.form-signin .form-control:focus {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
